import * as React from "react";
import {injectIntl, MessageDescriptor, WrappedComponentProps} from "react-intl";
import styled from "styled-components";

import {SettingEnum} from "./settingEnum";
import {ValueSelector} from "./SoundLight/Components/valueSelector";
import ValueSlider from "./SoundLight/Components/slider";
import {DeviceHardwareEnum, isGx8, isSTCB} from "../DeviceHardwareEnum";
import {
  IncomingRingTone,
  Led,
  LightMode,
  LowBatteryVoicePrompt,
  MuteSosPrompt,
  NotApplicable,
  ScreenBrightness,
  ScreenLightMode,
  SoundFilesLanguage,
  SoundsForCharging,
  StepCountDisplay,
  WatchFiveTheme
} from "./SoundLight/Components";
import GetPosition from "./Tracking/TrackingMode/getPosition";
import AutoToggle from "./Tracking/TrackingMode/autoToggle";
import GeneralSettings, {
  AclCheck,
  EnableOffButton,
  HealthHeartRateBloodPressure,
  StaticTooLong,
  Vibration,
  WatchRemoval
} from "./General/Tabs/generalSettings";
import {
  BloodPressure,
  CalibrateBloodPressureSetting,
  CalibrateDiastolicPressure,
  CalibrateSystolicPressure,
  HeartRate,
  HeartRateBloodPressureSetting,
  HeartRateBloodPressureSettings
} from "./General/Tabs/heartRateBloodPressure";
import DeviceLog, {DeviceAuditLog, DeviceCallLog} from "./General/Tabs/deviceLog";
import DeleteData, {DeleteHistory, DeleteSafemate, ResetSafemate, SwitchSafemate} from "./General/Tabs/deleteData";
// import Positioning, { PositionToggle, Satellites } from "./General/Tabs/positioning";
import Battery, {BatteryThreshold} from "./General/Tabs/battery";
import AlarmSettings, {
  ButtonBehaviour,
  ButtonSensitivity,
  DeliveryFormat,
  EnableRingTone,
  FallDetection,
  SilentAlarm,
  SOSCancellation,
  T4Vibration,
  TeamAlert,
  VoicePromptCallWait,
  VoicePromptSosAlarm
} from "./General/Tabs/alarmSettings";

import Tracking from "./Tracking";
import Geofence from "./Geofence";
import IndoorLocationCom from "./IndoorLocation";
import SoundLight from "./SoundLight";
import General from "./General";
import Info from "./Info";
import {PolicyNameEnum} from "../PolicyNameEnum";

import Cog from "../../Elements/Icon/Icons/Safemate/solid/Cog";
import Log from "../../Elements/Icon/Icons/Log";
import Bell from "../../Elements/Icon/Icons/Safemate/solid/Bell";
import LightbulbOn from "../../Elements/Icon/Icons/Safemate/outline/LightbulbOn";
import BatteryBolt from "../../Elements/Icon/Icons/Safemate/solid/BatteryBolt";
import Database from "../../Elements/Icon/Icons/Safemate/solid/Database";
import FallSensor from "../../Elements/Icon/Icons/Safemate/solid/FallSensor";
import HeartRateIcon from "../../Elements/Icon/Icons/Safemate/outline/HeartRateIcon";
import TrackingInterval, {NoTrackingInterval} from "./Tracking/TrackingOptions/trackingInterval";
import {ManualTracking} from "./Tracking/trackingInfo";
import {AcceptLBS, PositionToggle, Satellites} from "./Tracking/TrackingOptions/positioning";
import FindMe from "./Tracking/TrackingMode/findMe";
import {FallDownAlarm, ManDown, TiltAlert, WatchTwoRadioManDown} from "./General/Tabs/manDown";
import {GeneralSection, GeneralSectionSTBC,} from "./General/Tabs/gx8/generalSettings";
import CommunicationSettings, {
  GX8CommunicationSection,
  GX8CommunicationSectionSTCB
} from "./General/Tabs/gx8/communicationSettings";
import LightSoundSettings, {
  GX8SoundSyncSection,
  GX8SoundVolumeSection,
  GX8SoundVolumeSectionSTCB,
  GX8SoundSignalSection
} from "./General/Tabs/gx8/lightSoundSettings";
import {GX8BatterySection, GX8BatterySectionSTCB} from "./General/Tabs/gx8/batterySettings";
import {GdprReport, SignalStrengthReport} from "./General/Tabs/gx8/logsReports";
import Information, {RebootDevice} from "./General/Tabs/gx8/information";
import Gx8Log, {AuditLog, CallLog} from "./General/Tabs/gx8/log";
import Walktest from "./Walktest";
import SensorTable from "./Sensor/sensorTable";
import LocalLearning from "./Sensor/Add/localLearning";
import TwinDevice from "./General/Tabs/twinDevice";
import Clone from "../../Elements/Icon/Icons/FontAwesome/Clone";
import PowerSaving from "./Tracking/TrackingMode/powerSaving";
import {Device} from "@Safemate/Settings/types";
import {IndoorLocation} from "@Safemate/Settings/IndoorLocation/types";
import VoicePromptSettings, {
  GX8VoicePromptSection,
  GX8VoicePromptSectionSTCB
} from "./General/Tabs/gx8/voicePromptSettings";
import LightSettings, {
  GX8LightSection
} from "./General/Tabs/gx8/lightSettings";
import SelfcheckFail from "@Elements/Icon/Icons/Safemate/solid/SelfcheckFail";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle, faMicrophoneAlt, faVolumeUp} from "@fortawesome/pro-solid-svg-icons";
import LightbulbOnSolid from "@Elements/Icon/Icons/Safemate/solid/LightbulbOnSolid";
import Organisation from "./General/Tabs/organisation";
import SwapOrganisation from "./Organisation";
import SubUnits from "@Elements/Icon/Icons/menu/SubUnits";
import StepData, {PedometerToggle, StepInformation} from "./General/Tabs/stepData";
import Inactivity, {GX8InactivitySection} from "./General/Tabs/gx8/inactivity";
import InactiveIcon from '@Icons/Inactive';
import FeetWalk from "@Elements/Icon/Icons/Safemate/solid/FeetWalk";
import {Capabilities} from "@Safemate/Settings/Store/types";
import {APISettingEnum} from "@Safemate/Settings/APISettingEnum";
import AutoTracking from "@Safemate/Settings/Tracking/TrackingMode/autoTracking";


const Title = styled.span`
  display: flex;
  align-items: center;
  path{
    fill: ${props => props.theme.colors.textPrimary};
  }
`;

const TitleContent = styled.span`
  margin-left: 10px;
`;

interface LightHeaderProps extends WrappedComponentProps {
  message: MessageDescriptor;
}

export const Header = injectIntl(({ intl: { formatMessage }, message }: LightHeaderProps) => {
  return (
    <div>
      <h3>
        {formatMessage(message)}
      </h3>
    </div>
  )
})


export const DEFAULT: Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  [SettingEnum.LIGHT, 
    [<ValueSelector
      title={{ id: "ledStrength", defaultMessage: "Lysstyrke av/på-knapp" }}
      name="lightLevel"
      count={5}
    />]],
  [SettingEnum.SOUND,
    [<ValueSelector
      title={{ id: "volume", defaultMessage: "Høyttalervolum" }}
      name="soundLevel"
      startLevel={1}
      count={4}
    />,
    <SoundsForCharging/>,
    <IncomingRingTone/>]],
  [SettingEnum.TRACKING_MANUAL,
    [<ManualTracking />]],
  [SettingEnum.TRACKING_OPTIONS,
    [<PositionToggle/>, <Satellites/>, <AutoToggle />, <TrackingInterval/>]],
  [SettingEnum.GENERAL_SETTINGS,
    [<AclCheck/>, <StaticTooLong />]],
  [SettingEnum.DEVICE_LOG,
    [<DeviceAuditLog />, <DeviceCallLog />]],
  [SettingEnum.DELETE_DATA,
    [<SwitchSafemate />, <ResetSafemate />, <DeleteHistory />, <DeleteSafemate />]],
  /*[SettingEnum.POSITIONING,
    [<PositionToggle />, <Satellites />]],*/
  [SettingEnum.BATTERY,
    [<BatteryThreshold />]],
  [SettingEnum.ALARM_SETTINGS,
    [<DeliveryFormat />, <VoicePromptSosAlarm/>]],
  [SettingEnum.SOUND_LIGHT,
    []],
  [SettingEnum.TWIN_DEVICE,
    []],
  [SettingEnum.SIMULATE,
    []],
  [SettingEnum.ORGANIZATION,
    [<SwapOrganisation/>]]
]);

export const WATCH_ONE: Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  ...DEFAULT,
  [SettingEnum.LIGHT,
  [<NotApplicable />]],
  [SettingEnum.SOUND,
  [<ValueSelector
    title={{ id: "ringtoneVolume", defaultMessage: "Anropsvolum" }}
    name="soundLevelRingtone"
    count={3}
    label={[
      { id: "lowVol", defaultMessage: "Lavt" },
      { id: "mediumVol", defaultMessage: "Medium" },
      { id: "highVol", defaultMessage: "Høyt" },
    ]}
  />,
  <ValueSelector
    title={{ id: "callVolume", defaultMessage: "Samtalevolum" }}
    name="soundLevel"
    count={3}
    label={[
      { id: "lowVol", defaultMessage: "Lavt" },
      { id: "mediumVol", defaultMessage: "Medium" },
      { id: "highVol", defaultMessage: "Høyt" },
    ]}
  />
  ]],
  [SettingEnum.TRACKING_MANUAL,
    [<GetPosition />, <FindMe/>]],
  [SettingEnum.TRACKING_OPTIONS,
    [<PositionToggle/>, <Satellites/>, <AutoToggle />, <NoTrackingInterval/>, <AcceptLBS />]],
  [SettingEnum.POSITIONING,
    [<PositionToggle/>]],
  [SettingEnum.GENERAL_SETTINGS,
    [<AclCheck/>]]
]);

export const WATCH_THREE = WATCH_ONE;

export const WATCH_TWO: Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  ...DEFAULT,
  [SettingEnum.LIGHT,
    [
      <StepCountDisplay />,
      <ScreenBrightness />,
      <ScreenLightMode  />,
    ]],
  [SettingEnum.SOUND,
    [<LowBatteryVoicePrompt />]],
  [SettingEnum.TRACKING_MANUAL,
    [<ManualTracking />, <GetPosition />, <FindMe />]],
  [SettingEnum.TRACKING_OPTIONS,
    [<PositionToggle/>, <Satellites/>, <AutoToggle />, <TrackingInterval  />, <AcceptLBS />]],
  [SettingEnum.MAN_DOWN_SETTINGS,
    [
      <WatchTwoRadioManDown/>,
    ]],
  [SettingEnum.GENERAL_SETTINGS,
    [<EnableOffButton/>, <AclCheck/>, <Vibration/>, <HealthHeartRateBloodPressure />, <WatchRemoval />]],
  [SettingEnum.ALARM_SETTINGS,
    [<ButtonBehaviour/>,
      <ButtonSensitivity/>,
      <DeliveryFormat/>,
      <SilentAlarm/>,
      <TeamAlert/>,
      <VoicePromptSosAlarm/>
    ]],
  [SettingEnum.HEART_RATE_BLOOD_PRESSURE,
    [
      <HeartRateBloodPressureSetting />,
      <HeartRate/>,
      <BloodPressure/>,
      <CalibrateBloodPressureSetting/>,
      <CalibrateSystolicPressure/>,
      <CalibrateDiastolicPressure/>,
    ]],
  [SettingEnum.DEVICE_PEDOMETER,
    [
      <PedometerToggle />, <StepInformation />
    ]],
]);

export const WATCH_FIVE = new Map<SettingEnum, JSX.Element[]>([
  ...DEFAULT,
  [SettingEnum.LIGHT,
    [
      <WatchFiveTheme />,
      <StepCountDisplay />,
      <ScreenBrightness />,
      <ScreenLightMode  />,
    ]],
  [SettingEnum.SOUND,
    [<LowBatteryVoicePrompt />]],
  [SettingEnum.TRACKING_MANUAL,
    [<ManualTracking />, <GetPosition />, <FindMe />]],
  [SettingEnum.TRACKING_OPTIONS,
    [<PositionToggle/>, <Satellites/>, <AutoToggle />, <TrackingInterval  />, <AcceptLBS />]],
  [SettingEnum.GENERAL_SETTINGS,
    [<EnableOffButton/>, <AclCheck/>, <Vibration/>, <HealthHeartRateBloodPressure />, <WatchRemoval />]],
  [SettingEnum.ALARM_SETTINGS,
    [<ButtonBehaviour/>,
      <ButtonSensitivity/>,
      <DeliveryFormat/>,
      <SilentAlarm/>,
      <TeamAlert/>,
      <VoicePromptSosAlarm/>
    ]],
  [SettingEnum.HEART_RATE_BLOOD_PRESSURE,
    [
      <HeartRateBloodPressureSetting />,
      <HeartRate/>,
      <BloodPressure/>,
      <CalibrateBloodPressureSetting/>,
      <CalibrateSystolicPressure/>,
      <CalibrateDiastolicPressure/>,
    ]],
  [SettingEnum.DEVICE_PEDOMETER,
    [
      <PedometerToggle />, <StepInformation />
    ]],
]);

export const WATCH_SEVEN = new Map<SettingEnum, JSX.Element[]>([
  ...WATCH_FIVE,
  [SettingEnum.GENERAL_SETTINGS,
    [<AclCheck/>, <Vibration/>]],
  [SettingEnum.LIGHT,
    [
      <StepCountDisplay />,
    ]],
  [SettingEnum.SOUND,
    [<LowBatteryVoicePrompt />, <MuteSosPrompt/>]],
]);

export const WATCH_TWO_4G = new Map<SettingEnum, JSX.Element[]>([
  ...WATCH_SEVEN,
  [SettingEnum.GENERAL_SETTINGS,
    [<AclCheck/>]],
  [SettingEnum.LIGHT,
    [
      <StepCountDisplay />,
    ]],
  [SettingEnum.SOUND,
    [<LowBatteryVoicePrompt />]],
  [SettingEnum.ALARM_SETTINGS,
    [<ButtonBehaviour/>,
      <DeliveryFormat/>,
      <TeamAlert/>,
      <VoicePromptSosAlarm/>
    ]],
]);

export const TRIGGER_ONE: Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  ...DEFAULT,
  [SettingEnum.ALARM_SETTINGS,
    [<ButtonBehaviour/>,
    <ButtonSensitivity/>,
    <DeliveryFormat/>,
    <FallDetection/>]]
]);

export const TRIGGER_THREE: Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  ...DEFAULT,
  [SettingEnum.TRACKING_MANUAL,
    [<ManualTracking />, <GetPosition />]],
  [SettingEnum.LIGHT,
    [<Led />]],
  [SettingEnum.SOUND,
    [<NotApplicable />]],
  [SettingEnum.TRACKING_OPTIONS, 
    [<PositionToggle/>, <Satellites/>, <AutoToggle/>, <PowerSaving/>, <TrackingInterval/>]],
  [SettingEnum.GENERAL_SETTINGS,
    [<AclCheck/>]],
  [SettingEnum.ALARM_SETTINGS,
    [...DEFAULT.get(SettingEnum.ALARM_SETTINGS), <FallDetection/>, <SilentAlarm/>]]

]);

export const GTX_SOLE: Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  ...DEFAULT,
  [SettingEnum.TRACKING_MANUAL,
    []],
  [SettingEnum.TRACKING_OPTIONS,
    [<Satellites/>, ]],
  [SettingEnum.GENERAL_SETTINGS,
    [<StaticTooLong />]],
  [SettingEnum.DEVICE_LOG,
    [<DeviceAuditLog />]],
  [SettingEnum.LIGHT,
    [<NotApplicable />]],
  [SettingEnum.SOUND,
    [<NotApplicable />]],

]);

export const TRIGGER_FOUR: Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  ...DEFAULT,
  [SettingEnum.TRACKING_MANUAL,
    [<ManualTracking />, <GetPosition />, <FindMe/>]],
  [SettingEnum.TRACKING_OPTIONS,
    [<PositionToggle/>, <Satellites/>, <AutoToggle />, <TrackingInterval  />, <AcceptLBS />]],
  [SettingEnum.LIGHT,
    [<Led/>]],
  [SettingEnum.SOUND,
    [<ValueSlider
      title={{ id: "microphoneSensitivityToolTipTitle", defaultMessage: "Mikrofonsensitivitet" }}
      name="micVolume"
      limit={[0, 15]}
    />,
    <ValueSlider
      title={{ id: "volume", defaultMessage: "Høyttalervolum" }}
      name="soundLevel"
      limit={[0, 100]}
    />,
    <ValueSlider
      title={{ id: "ringtoneVolume", defaultMessage: "Anropsvolum" }}
      name="soundLevelRingtone"
      limit={[0, 100]}
    />,
    <ValueSlider
      title={{ id: "voicePromptVolume", defaultMessage: "Talemeldingvolum" }}
      name="voicePromptVolume"
      limit={[0, 100]}
    />,
    <SoundsForCharging/>, <SoundFilesLanguage/> ]],
  [SettingEnum.ALARM_SETTINGS, 
    [<ButtonBehaviour/>,
    <ButtonSensitivity/>,
    <DeliveryFormat/>,
    <T4Vibration/>,
    <SilentAlarm/>,
    <SOSCancellation />,
    <VoicePromptSosAlarm/>,
    <VoicePromptCallWait/>,
    <EnableRingTone/>
    ]],
  [SettingEnum.GENERAL_SETTINGS,
    [<EnableOffButton/>, <AclCheck/>]],
  [SettingEnum.MAN_DOWN_SETTINGS,
    [<FallDownAlarm/>,
    <ValueSlider
      title={{ id: "fallDownSensitivity", defaultMessage: "Fallalarm sensitivitet" }}
      name="fallDownSensitivity"
      parent="fallDownAlert"
      limit={[1, 9]}
    />,
    <TiltAlert/>,
    <ValueSlider
      title={{ id: "tiltAngle", defaultMessage: "Tiltalarm vinkel" }}
      name="tiltAngle"
      parent="tiltAlert"
      limit={[0, 90]}
    />,
    <ValueSlider
      title={{ id: "tiltTime", defaultMessage: "Tiltalarm tid" }}
      name="tiltTime"
      parent="tiltAlert"
      limit={[1, 3600]}
    />,
    ]],
  [SettingEnum.DEVICE_PEDOMETER,
    [
      <PedometerToggle />, <StepInformation />
    ]],
]);

export const TRIGGER_THREE_E = TRIGGER_FOUR;
export const TRACK_TWO = TRIGGER_FOUR;
export const WATCH_FOUR = TRIGGER_FOUR;
export const WATCH_SIX = new Map<SettingEnum, JSX.Element[]>([
  ...TRIGGER_FOUR,
  [SettingEnum.LIGHT,
    [
      <StepCountDisplay />,
      <ValueSlider
      title={{ id: "screenBrightness", defaultMessage: "Screen brightness" }}
      name="screenBrightness"
      limit={[1, 10]}
    />]],
  [SettingEnum.GENERAL_SETTINGS,
    [<AclCheck/>]],
  [SettingEnum.ALARM_SETTINGS,
    [<ButtonBehaviour/>,
      <ButtonSensitivity/>,
      <DeliveryFormat/>,
      <T4Vibration/>,
      <SOSCancellation />,
      <VoicePromptSosAlarm/>,
      <VoicePromptCallWait/>,
      <EnableRingTone/>
    ]],
  [SettingEnum.MAN_DOWN_SETTINGS,
    [<FallDownAlarm/>,
      <ValueSlider
        title={{ id: "fallDownSensitivity", defaultMessage: "Fallalarm sensitivitet" }}
        name="fallDownSensitivity"
        parent="fallDownAlert"
        limit={[1, 9]}
      />,
    ]],
]);

export const SAFEMATE_HELP: Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  ...DEFAULT,
  [SettingEnum.LIGHT,
    [<NotApplicable />]],
  [SettingEnum.SOUND,
    [<NotApplicable />]],
  [SettingEnum.TRACKING_OPTIONS,
    [<PositionToggle/>, <AutoToggle />, <TrackingInterval/>]]
]);

export const TRACK_ONE: Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  ...DEFAULT,
  [SettingEnum.LIGHT,
    [<LightMode />]],
  [SettingEnum.SOUND,
    [<NotApplicable />]],
  [SettingEnum.TRACKING_MANUAL,
    DEFAULT.get(SettingEnum.TRACKING_MANUAL) as JSX.Element[]],
  [SettingEnum.TRACKING_OPTIONS,
    [<PositionToggle/>, <Satellites/>, <AutoToggle />, <TrackingInterval/>]],
  [SettingEnum.ALARM_SETTINGS,
    [<ButtonBehaviour/>,
      <ButtonSensitivity/>,
      <DeliveryFormat/>,
      <SilentAlarm/>]],
]);

export const TRIGGER_TWO: Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  ...TRACK_ONE,
  [SettingEnum.GENERAL_SETTINGS,
    [...TRACK_ONE.get(SettingEnum.GENERAL_SETTINGS), <EnableOffButton/>]],
  [SettingEnum.TRACKING_OPTIONS,
    [<PositionToggle/>, <Satellites/>, <AutoToggle />, <TrackingInterval/>]],
]);

export const TRIGGER_TWO_4G : Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  ...TRIGGER_TWO,
  [SettingEnum.TRACKING_MANUAL,
    [<ManualTracking />, <GetPosition />]],
  [SettingEnum.MAN_DOWN_SETTINGS,
    [<FallDownAlarm/>,
      <ValueSlider
        title={{ id: "fallDownSensitivity", defaultMessage: "Fallalarm sensitivitet" }}
        name="fallDownSensitivity"
        parent="fallDownAlert"
        limit={[1, 9]}
      />,
    ]],
  [SettingEnum.ALARM_SETTINGS,
    [<ButtonBehaviour/>,
      <ButtonSensitivity/>,
      <DeliveryFormat/>,
      <SilentAlarm/>,
      <SOSCancellation />,
    ]],
  [SettingEnum.LIGHT,
    [<LightMode />]],
  [SettingEnum.SOUND,
    [
      <ValueSlider
        title={{ id: "volume", defaultMessage: "Høyttalervolum" }}
        name="soundLevel"
        limit={[1, 100]}
      />,
      <ValueSlider
        title={{ id: "ringtoneVolume", defaultMessage: "Anropsvolum" }}
        name="soundLevelRingtone"
        limit={[0, 8]}
      />,
    ]],
  [SettingEnum.GENERAL_SETTINGS,
    [
      <EnableOffButton/>, <AclCheck/>
    ]],
]);

export const TRACK_FOUR : Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  ...TRIGGER_TWO_4G,
  [SettingEnum.TRACKING_MANUAL,
    [<ManualTracking />, <GetPosition />]],
  [SettingEnum.MAN_DOWN_SETTINGS,
    []],
  [SettingEnum.ALARM_SETTINGS,
    []],
  [SettingEnum.LIGHT,
    []],
  [SettingEnum.SOUND,
    []],
  [SettingEnum.GENERAL_SETTINGS,
    []],
]);

export const TRACK_THREE: Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  ...DEFAULT,
  [SettingEnum.LIGHT,
    [<Led />]],
  [SettingEnum.SOUND,
    [<NotApplicable />]],
  [SettingEnum.TRACKING_MANUAL,
    [<ManualTracking />, <GetPosition/>]],
  [SettingEnum.TRACKING_OPTIONS,
    [<PositionToggle/>, <Satellites/>, <TrackingInterval/>]],
  [SettingEnum.ALARM_SETTINGS, 
    [<DeliveryFormat/>,
    <FallDetection/>]],
]);


export const SAFEMATE_HOME: Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  [SettingEnum.GX8_GENERAL,
    [<GeneralSection/>]],
  [SettingEnum.GX8_COMMUNICATION,
    [<GX8CommunicationSection/>]],
  [SettingEnum.GX8_SOUND,
    [<GX8SoundSyncSection/>, <GX8SoundVolumeSection/>, <GX8SoundSignalSection/>]],
  [SettingEnum.GX8_LIGHT,
    [<GX8LightSection/>]],
  [SettingEnum.GX8_VOICE_PROMPT,
    [<GX8VoicePromptSection/>]],
  [SettingEnum.GX8_BATTERY,
    [<GX8BatterySection/>]],
  [SettingEnum.INACTIVITY_EVENT,
    [<GX8InactivitySection/>]],
  [SettingEnum.GX8_INFORMATION,
    [<ResetSafemate/>, <DeleteHistory/>, <RebootDevice/>, <DeleteSafemate/>]],
  [SettingEnum.GX8_LOG,
    [<SignalStrengthReport/>, <GdprReport/>, <AuditLog/>, <CallLog/>]],
  [SettingEnum.SENSOR, 
    [<LocalLearning/>]],
  [SettingEnum.ORGANIZATION,
    [<SwapOrganisation/>]]
  ])

export const SAFEMATE_HOME_DT35 = SAFEMATE_HOME;
export const SAFEMATE_HOME_MAX = SAFEMATE_HOME;
export const SAFEMATE_HOME_STCB1 : Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  [SettingEnum.GX8_GENERAL,
    [<GeneralSectionSTBC/>]],
  [SettingEnum.GX8_COMMUNICATION,
    [<GX8CommunicationSectionSTCB/>]],
  [SettingEnum.GX8_SOUND,
    [<GX8SoundVolumeSectionSTCB/>, <GX8SoundSignalSection/>]],
  [SettingEnum.GX8_VOICE_PROMPT,
    [<GX8VoicePromptSectionSTCB/> ]],
  [SettingEnum.GX8_BATTERY,
    [<GX8BatterySectionSTCB/>]],
  [SettingEnum.GX8_INFORMATION,
    [<ResetSafemate/>, <DeleteHistory/>, <RebootDevice/>, <DeleteSafemate/>]],
  [SettingEnum.GX8_LOG,
    [<AuditLog/>, <CallLog/>]],
  [SettingEnum.ORGANIZATION,
    [<SwapOrganisation/>]]
]);

export const ELIZA : Map<SettingEnum, JSX.Element[]> = new Map<SettingEnum, JSX.Element[]>([
  ...DEFAULT,
  [SettingEnum.ALARM_SETTINGS,
    [<DeliveryFormat/>]],
  [SettingEnum.LIGHT,
    []],
  [SettingEnum.SOUND,
    []],
  [SettingEnum.GENERAL_SETTINGS,
    []]

]);


export const DeviceComponents: Map<DeviceHardwareEnum, Map<SettingEnum, JSX.Element[]>> = new Map<DeviceHardwareEnum, Map<SettingEnum, JSX.Element[]>>([
  [DeviceHardwareEnum.DEFAULT, DEFAULT],
  [DeviceHardwareEnum.WATCH_ONE, WATCH_ONE],
  [DeviceHardwareEnum.WATCH_TWO, WATCH_TWO],
  [DeviceHardwareEnum.WATCH_TWO_4G, WATCH_TWO_4G],
  [DeviceHardwareEnum.WATCH_THREE, WATCH_THREE],
  [DeviceHardwareEnum.WATCH_FIVE, WATCH_FIVE],
  [DeviceHardwareEnum.WATCH_SEVEN, WATCH_SEVEN],
  [DeviceHardwareEnum.TRIGGER_ONE, TRIGGER_ONE],
  [DeviceHardwareEnum.TRIGGER_TWO, TRIGGER_TWO],
  [DeviceHardwareEnum.TRIGGER_THREE, TRIGGER_THREE],
  [DeviceHardwareEnum.TRIGGER_THREE_E, TRIGGER_THREE_E],
  [DeviceHardwareEnum.TRIGGER_FOUR, TRIGGER_FOUR],
  [DeviceHardwareEnum.TRACK_ONE, TRACK_ONE],
  [DeviceHardwareEnum.TRACK_THREE, TRACK_THREE],
  [DeviceHardwareEnum.SAFEMATE_HELP, SAFEMATE_HELP],
  [DeviceHardwareEnum.SAFEMATE_HOME, SAFEMATE_HOME],
  [DeviceHardwareEnum.SAFEMATE_HOME_DT35, SAFEMATE_HOME_DT35],
  [DeviceHardwareEnum.SAFEMATE_HOME_MAX, SAFEMATE_HOME_MAX],
  [DeviceHardwareEnum.TRIGGER_TWO_4G, TRIGGER_TWO_4G],
  [DeviceHardwareEnum.WATCH_FOUR, WATCH_FOUR],
  [DeviceHardwareEnum.TRACK_TWO, TRACK_TWO],
  [DeviceHardwareEnum.GTX_SOLE, GTX_SOLE],
  [DeviceHardwareEnum.WATCH_SIX, WATCH_SIX],
  [DeviceHardwareEnum.TRACK_FOUR, TRACK_FOUR],
  [DeviceHardwareEnum.SAFEMATE_HOME_STCB1, SAFEMATE_HOME_STCB1],
  [DeviceHardwareEnum.ELIZA, ELIZA],
])

export const APISettingComponents: Map<APISettingEnum, JSX.Element> = new Map<APISettingEnum, JSX.Element>([
  [APISettingEnum.DISABLE_POSITIONING, <PositionToggle/>],
  [APISettingEnum.GPS_SAT_CRITERIA, <Satellites/>],
  [APISettingEnum.AUTO_TRACKING, <AutoToggle/>],
])

export const SettingToPolicyMap: Map<SettingEnum, PolicyNameEnum> = new Map<SettingEnum, PolicyNameEnum>(
  [
    [SettingEnum.TRACKING, PolicyNameEnum.DEVICE_TRACKING],
    [SettingEnum.GEOFENCE, PolicyNameEnum.DEVICE_GEOFENCE],
    [SettingEnum.INDOOR, PolicyNameEnum.DEVICE_INDOOR],
    [SettingEnum.INDOOR_LOCATION, PolicyNameEnum.DEVICE_INDOOR],
    [SettingEnum.SENSOR, PolicyNameEnum.DEVICE_SENSOR],
    [SettingEnum.SENSOR_TEMP, PolicyNameEnum.DEVICE_SENSOR],
    [SettingEnum.ORGANIZATION, PolicyNameEnum.DEVICE_ORGANIZATION],
    [SettingEnum.INFO, PolicyNameEnum.DEVICE_INFO],
    [SettingEnum.GENERAL, PolicyNameEnum.GENERAL_SETTINGS],
    [SettingEnum.GENERAL_SETTINGS, PolicyNameEnum.SAFEMATE_GENERAL],
    [SettingEnum.DEVICE_LOG, PolicyNameEnum.SAFEMATE_DEVICE_LOGS],
    [SettingEnum.DELETE_DATA, PolicyNameEnum.SAFEMATE_DELETE_DATA],
    [SettingEnum.SOUND_LIGHT, PolicyNameEnum.DEVICE_LIGHT_SOUND],
    [SettingEnum.POSITIONING, PolicyNameEnum.SAFEMATE_POSITIONING],
    [SettingEnum.BATTERY, PolicyNameEnum.SAFEMATE_BATTERY_TRESHHOLD],
    [SettingEnum.ALARM_SETTINGS, PolicyNameEnum.SAFEMATE_ALARM],
    [SettingEnum.MAN_DOWN_SETTINGS, PolicyNameEnum.SAFEMATE_MAN_DOWN],
    [SettingEnum.HEART_RATE_BLOOD_PRESSURE, PolicyNameEnum.SAFEMATE_HEART_RATE_BLOOD_PRESSURE],
    [SettingEnum.GX8_SOUND, PolicyNameEnum.GX8_LIGHT_SOUND],
    [SettingEnum.GX8_LIGHT, PolicyNameEnum.GX8_LIGHT_SOUND],
    [SettingEnum.GX8_VOICE_PROMPT, PolicyNameEnum.GX8_LIGHT_SOUND],
    [SettingEnum.GX8_BATTERY, PolicyNameEnum.GX8_BATTERY],
    [SettingEnum.INACTIVITY_EVENT, PolicyNameEnum.GX8_GENERAL],
    [SettingEnum.GX8_LOGS_REPORT, PolicyNameEnum.GX8_LOGS_REPORT],
    [SettingEnum.GX8_GENERAL, PolicyNameEnum.GX8_GENERAL],
    [SettingEnum.GX8_COMMUNICATION, PolicyNameEnum.GX8_COMMUNICATION],
    [SettingEnum.GX8_INFORMATION, PolicyNameEnum.GX8_INFORMATION],
    [SettingEnum.GX8_LOG, PolicyNameEnum.GX8_LOGS_REPORT],
    [SettingEnum.EVENT_CONFIG, PolicyNameEnum.DEVICE_SETTINGS],
    [SettingEnum.WALKTEST, PolicyNameEnum.DEVICE_SETTINGS],
    [SettingEnum.TWIN_DEVICE, PolicyNameEnum.GENERAL_SETTINGS],
    [SettingEnum.SIMULATE, PolicyNameEnum.GENERAL_SETTINGS],
    [SettingEnum.DEVICE_PEDOMETER, PolicyNameEnum.GENERAL_SETTINGS]
  ]
)

export interface GSMRange{
  low: number,
  high: number,
  label: string,
  desc: string
}

const gsm9: GSMRange = {
  low: 0,
  high: 9,
  label: "gsmStrengthDescSafemateHome",
  desc: "0 - 5, over 3 er et godt signal"
}

const gsm31: GSMRange = {
  low: 0,
  high: 31,
  label: "gsmStrengthDescTriggerFour",
  desc: "0 - 31, over 20 er et godt signal"
}

export const gsm100: GSMRange = {
  low: 0,
  high: 100,
  label: "gsmStrengthDescWatchTwo",
  desc: "0 - 100, over 65 er et godt signal"
}

export const gsm120: GSMRange = {
  low: -113,
  high: -51,
  label: "gsmStrengthDescSTCB",
  desc: "-113 to -51, over -90 er et godt signal"
}


export const supportGsmStrength: Map<DeviceHardwareEnum, GSMRange> = new Map<DeviceHardwareEnum, GSMRange>(
  [
    [DeviceHardwareEnum.ALL, gsm100],
    [DeviceHardwareEnum.TRACK_ONE, gsm31],
    [DeviceHardwareEnum.TRACK_TWO, gsm31],
    [DeviceHardwareEnum.TRACK_THREE, gsm31],
    [DeviceHardwareEnum.TRACK_FOUR, gsm31],
    [DeviceHardwareEnum.TRIGGER_TWO, gsm31],
    [DeviceHardwareEnum.TRIGGER_TWO_4G, gsm31],
    [DeviceHardwareEnum.TRIGGER_THREE, gsm31],
    [DeviceHardwareEnum.TRIGGER_FOUR, gsm31],
    [DeviceHardwareEnum.TRIGGER_THREE_E, gsm31],
    [DeviceHardwareEnum.TRIGGER_FIVE, gsm31],
    [DeviceHardwareEnum.WATCH_SIX, gsm31],
    [DeviceHardwareEnum.WATCH_ONE, gsm100],
    [DeviceHardwareEnum.WATCH_TWO, gsm100],
    [DeviceHardwareEnum.WATCH_THREE, gsm100],
    [DeviceHardwareEnum.WATCH_FOUR, gsm100],
    [DeviceHardwareEnum.WATCH_FIVE, gsm100],
    [DeviceHardwareEnum.WATCH_SEVEN, gsm100],
    [DeviceHardwareEnum.WATCH_TWO_4G, gsm100],
    [DeviceHardwareEnum.SAFEMATE_HOME,  gsm9],
    [DeviceHardwareEnum.SAFEMATE_HOME_DT35,  gsm9],
    [DeviceHardwareEnum.SAFEMATE_HOME_MAX,  gsm9],
    [DeviceHardwareEnum.SAFEMATE_HOME_STCB1,  gsm120],

  ]
)

export const supportWifiScan: Map<DeviceHardwareEnum, boolean> = new Map<DeviceHardwareEnum, boolean>(
  [
    [DeviceHardwareEnum.TRIGGER_FOUR, true],
    [DeviceHardwareEnum.TRIGGER_THREE_E, true],
    [DeviceHardwareEnum.WATCH_FOUR, true],
    [DeviceHardwareEnum.TRACK_TWO, true],
    [DeviceHardwareEnum.WATCH_SIX, true]

  ]
)

export const excludeConnectedHeader: Map<DeviceHardwareEnum, boolean> = new Map<DeviceHardwareEnum, boolean>(
  [
    [DeviceHardwareEnum.TRIGGER_ONE, true],
    [DeviceHardwareEnum.SAFEMATE_HELP, true]
  ]
)

export const hasDisplay: Map<DeviceHardwareEnum, boolean> = new Map<DeviceHardwareEnum, boolean>(
  [
    [DeviceHardwareEnum.WATCH_ONE, true],
    [DeviceHardwareEnum.WATCH_TWO, true],
    [DeviceHardwareEnum.WATCH_THREE, true],
    [DeviceHardwareEnum.WATCH_FOUR, true],
    [DeviceHardwareEnum.WATCH_FIVE, true],
    [DeviceHardwareEnum.WATCH_SIX, true],
    [DeviceHardwareEnum.WATCH_SEVEN, true],
  ]
)

interface GeneralTitleProps extends WrappedComponentProps{
  icon?: JSX.Element;
  title: string;
  ignoreTranslate?: boolean;
}

export const GeneralTitle = injectIntl(({ intl: { formatMessage }, icon, title, ignoreTranslate }: GeneralTitleProps) =>
    <Title>
      {icon && React.cloneElement(icon, {inline: true, size: "medium"})}
      <TitleContent>{ignoreTranslate ? title : formatMessage({id: title, defaultMessage: title})}</TitleContent>
    </Title>
)

export interface GeneralTabs{
  tab: SettingEnum;
  comp: JSX.Element;
  title: JSX.Element;
}

export const getDeviceSettings = (dehaId: number, capability: Capabilities, isPrivate: boolean, beta: boolean, settingComponents: Map<SettingEnum, JSX.Element[]>) => {
  // gx-8 return from Device components
  if( isGx8(dehaId) ){
    return settingComponents;
  }

  const settings = new Map<SettingEnum, JSX.Element[]>();
  // TRACKING_MANUAL
  if(capability.manualTracking || capability.positioningRequest || capability.findMe){
    let elements: JSX.Element[] = [];
    if(capability.manualTracking) elements.push(<ManualTracking />);
    if(capability.positioningRequest) elements.push(<GetPosition />);
    if(capability.findMe) elements.push(<FindMe />);

    settings.set(SettingEnum.TRACKING_MANUAL, elements);
  } else {
    settings.set(SettingEnum.TRACKING_MANUAL, []);
  }
  // TRACKING_OPTIONS
  if( capability.positioning || capability.satellites || capability.trackingInterval ){
    let elements: JSX.Element[] = [];
    if(capability.positioning && capability.alarm) elements.push(<PositionToggle/>);
    if(capability.satellites) elements.push(<Satellites/>);
    if(capability.trackingAuto) elements.push(<AutoToggle/>);
    if(capability.trackingInterval) elements.push(<TrackingInterval/>);

    settings.set(SettingEnum.TRACKING_OPTIONS, elements);
  } else {
    settings.set(SettingEnum.TRACKING_OPTIONS, []);
  }

  if(capability.batteryPercentage){
    settings.set(SettingEnum.BATTERY, [<BatteryThreshold/>]);
  } else {
    settings.set(SettingEnum.BATTERY, []);
  }

  let logElements: JSX.Element[] = [];
  logElements.push(<DeviceAuditLog/>);
  if(capability.callGsm ) logElements.push(<DeviceCallLog/>);
  settings.set(SettingEnum.DEVICE_LOG, logElements);


  settings.set(SettingEnum.DELETE_DATA, [<SwitchSafemate/>, <ResetSafemate/>, <DeleteHistory/>, <DeleteSafemate/>]);

  if( capability.twin )  settings.set(SettingEnum.TWIN_DEVICE, [<TwinDevice />]);

  if( !isPrivate ) settings.set(SettingEnum.ORGANIZATION, [<SwapOrganisation />]);



  // Add Alarm , general, Light and Sound settings in DeviceComponents for all device hardware

  if( capability.motion ) settings.set( SettingEnum.DEVICE_PEDOMETER, settingComponents.get(SettingEnum.DEVICE_PEDOMETER) );
  if( (capability.vitalsPulse || capability.vitalsBloodPressure) && beta ) settings.set( SettingEnum.HEART_RATE_BLOOD_PRESSURE, settingComponents.get(SettingEnum.HEART_RATE_BLOOD_PRESSURE) );

  if( capability.fallImpact || capability.fallTilt ) {
    if(dehaId === DeviceHardwareEnum.WATCH_SIX){
      if(beta){
        settings.set( SettingEnum.MAN_DOWN_SETTINGS, settingComponents.get(SettingEnum.MAN_DOWN_SETTINGS) );
      }
    } else {
      settings.set( SettingEnum.MAN_DOWN_SETTINGS, settingComponents.get(SettingEnum.MAN_DOWN_SETTINGS) );
    }
  }

  settings.set( SettingEnum.ALARM_SETTINGS, settingComponents.get(SettingEnum.ALARM_SETTINGS) );
  settings.set( SettingEnum.GENERAL_SETTINGS, settingComponents.get(SettingEnum.GENERAL_SETTINGS) );

  const light = settingComponents.get(SettingEnum.LIGHT);
  if( light && light.length > 0 ){
    settings.set( SettingEnum.LIGHT, light );
  }
  const sound = settingComponents.get(SettingEnum.SOUND);
  if(sound && sound.length > 0){
    settings.set( SettingEnum.SOUND, sound );
  }

  if( ( light && light.length > 0 ) || (sound && sound.length > 0) ){
    settings.set(SettingEnum.SOUND_LIGHT,[...light, ...sound]);
  }


  return settings;
}

type GetGeneralTabs = (dehaId: DeviceHardwareEnum, device: Device, isPrivate: boolean, capabilities: Capabilities, components: Map<SettingEnum, JSX.Element[]>, beta?: boolean, translator?: boolean) => GeneralTabs[];

export const getGeneralTabs: GetGeneralTabs = (dehaId, device, isPrivate, capabilities, components, beta, translator) => {

  if(device.twinChild){
    return [{tab: SettingEnum.DEVICE_LOG, comp: <DeviceLog components={components} />, title: <GeneralTitle icon={<Log/>} title={SettingEnum.DEVICE_LOG} />}];
  }

  const defaultTabs = [];

  if(components.has(SettingEnum.GENERAL_SETTINGS) && components.get(SettingEnum.GENERAL_SETTINGS) && components.get(SettingEnum.GENERAL_SETTINGS).length > 0 ){
    defaultTabs.push(
      {tab: SettingEnum.GENERAL_SETTINGS, comp: <GeneralSettings capabilities={capabilities}/>, title: <GeneralTitle icon={<Cog/>} title={SettingEnum.GENERAL_SETTINGS} />}
    )
  }

  defaultTabs.push({tab: SettingEnum.DEVICE_LOG, comp: <DeviceLog components={components} />, title: <GeneralTitle icon={<Log/>} title={SettingEnum.DEVICE_LOG} />});
  defaultTabs.push({tab: SettingEnum.DELETE_DATA, comp: <DeleteData components={components} />, title: <GeneralTitle icon={<Database/>} title={SettingEnum.DELETE_DATA} />});

  if(components.has(SettingEnum.ORGANIZATION) && components.get(SettingEnum.ORGANIZATION) && components.get(SettingEnum.ORGANIZATION).length > 0 ){
    defaultTabs.push(
      {tab: SettingEnum.ORGANIZATION, comp: <Organisation components={components} />, title: <GeneralTitle icon={<SubUnits/>} title={SettingEnum.ORGANIZATION} />}
    )
  }

  if(components.has(SettingEnum.BATTERY) && components.get(SettingEnum.BATTERY) && components.get(SettingEnum.BATTERY).length > 0 ){
    defaultTabs.push(
      {tab: SettingEnum.BATTERY, comp: <Battery components={components} />, title: <GeneralTitle icon={<BatteryBolt/>} title={SettingEnum.BATTERY} />}
    )
  }

  if(components.has(SettingEnum.ALARM_SETTINGS) && components.get(SettingEnum.ALARM_SETTINGS) && components.get(SettingEnum.ALARM_SETTINGS).length > 0){
    defaultTabs.push({
      tab: SettingEnum.ALARM_SETTINGS, comp: <AlarmSettings components={components}/>, title: <GeneralTitle icon={<Bell/>} title={SettingEnum.ALARM_SETTINGS} />
    })
  }

  if(components.has(SettingEnum.SOUND_LIGHT) && components.get(SettingEnum.SOUND_LIGHT) && components.get(SettingEnum.SOUND_LIGHT).length > 0){

    const display = hasDisplay.get(dehaId);

    defaultTabs.push({
      tab: SettingEnum.SOUND_LIGHT, comp: <SoundLight components={components} />, title: <GeneralTitle icon={<LightbulbOn/>} title={display ? SettingEnum.DISPLAY_SOUND_SETTINGS : SettingEnum.LIGHT_SOUND_SETTINGS} />
    })
  }

    if(components.has(SettingEnum.MAN_DOWN_SETTINGS) && components.get(SettingEnum.MAN_DOWN_SETTINGS) && components.get(SettingEnum.MAN_DOWN_SETTINGS).length > 0){
      defaultTabs.push({
        tab: SettingEnum.MAN_DOWN_SETTINGS, comp: <ManDown components={components} />, title: <GeneralTitle icon={<FallSensor/>} title={SettingEnum.MAN_DOWN_SETTINGS}/>
      })
    }

  if(components.has(SettingEnum.HEART_RATE_BLOOD_PRESSURE)  && components.get(SettingEnum.HEART_RATE_BLOOD_PRESSURE) && components.get(SettingEnum.HEART_RATE_BLOOD_PRESSURE).length > 0){
    defaultTabs.push({
      tab: SettingEnum.HEART_RATE_BLOOD_PRESSURE, comp: <HeartRateBloodPressureSettings components={components} />, title: <GeneralTitle icon={<HeartRateIcon/>} title={SettingEnum.HEART_RATE_BLOOD_PRESSURE}/>
    })
  }

  if(components.has(SettingEnum.DEVICE_PEDOMETER)  && components.get(SettingEnum.DEVICE_PEDOMETER) && components.get(SettingEnum.DEVICE_PEDOMETER).length > 0 && beta){
    defaultTabs.push({
      tab: SettingEnum.DEVICE_PEDOMETER, comp: <StepData components={components}/>, title: <GeneralTitle icon={<FeetWalk inline size="medium"/>} title={SettingEnum.DEVICE_PEDOMETER}/>
    })
  }

  if(components.has(SettingEnum.TWIN_DEVICE) && components.get(SettingEnum.TWIN_DEVICE) && components.get(SettingEnum.TWIN_DEVICE).length > 0){
    defaultTabs.push({tab: SettingEnum.TWIN_DEVICE, comp: <TwinDevice/>, title: <GeneralTitle icon={<Clone medium/>} title={SettingEnum.TWIN_DEVICE} />})
  }

  /*
  This doesn't really work atm
  if(translator){
    defaultTabs.push(
      {tab: SettingEnum.SIMULATE, comp: <Simulate/>, title: <GeneralTitle icon={<Cog medium/>} title={SettingEnum.SIMULATE} />}
    )
  }
  */

  if(isGx8(dehaId)){
    const tabs = [
      {tab: SettingEnum.GX8_GENERAL, comp: <GeneralSettings/>, title: <GeneralTitle icon={<Cog inline size="medium"/>} title={SettingEnum.GX8_GENERAL}/>},
      {tab: SettingEnum.GX8_COMMUNICATION, comp: <CommunicationSettings/>, title: <GeneralTitle icon={<SelfcheckFail inline size="medium"/>} title={SettingEnum.GX8_COMMUNICATION}/>},
      {tab: SettingEnum.GX8_SOUND, comp: <LightSoundSettings/>, title: <GeneralTitle icon={<FontAwesomeIcon style={{width: "24px", height: "24px"}} icon={faVolumeUp} size="lg" />} title={SettingEnum.GX8_SOUND}/>},
      {tab: SettingEnum.GX8_LIGHT, comp: <LightSettings/>, title: <GeneralTitle icon={<LightbulbOnSolid inline size="medium"/>} title={SettingEnum.GX8_LIGHT}/>},
      {tab: SettingEnum.GX8_VOICE_PROMPT, comp: <VoicePromptSettings/>, title: <GeneralTitle icon={<FontAwesomeIcon style={{width: "24px", height: "24px"}} icon={faMicrophoneAlt} size="lg" />} title={SettingEnum.GX8_VOICE_PROMPT}/>},
      {tab: SettingEnum.GX8_BATTERY, comp: <Battery components={components} />, title: <GeneralTitle icon={<BatteryBolt inline size="medium"/>} title={SettingEnum.GX8_BATTERY}/>},
      {tab: SettingEnum.INACTIVITY_EVENT, comp: <Inactivity/>, title: <GeneralTitle icon={<InactiveIcon inline size="medium"/>} title={SettingEnum.INACTIVITY_EVENT}/>},
      {tab: SettingEnum.GX8_INFORMATION, comp: <Information/>, title: <GeneralTitle icon={<FontAwesomeIcon style={{width: "24px", height: "24px"}} icon={faInfoCircle} size="lg" />} title={SettingEnum.GX8_INFORMATION}/>},
      {tab: SettingEnum.GX8_LOG, comp: <Gx8Log/>, title: <GeneralTitle icon={<Log inline size="medium"/>} title={SettingEnum.GX8_LOG}/>}
    ]
    if(!isPrivate){
      tabs.push(
        {tab: SettingEnum.ORGANIZATION, comp: <Organisation components={components} />, title: <GeneralTitle icon={<SubUnits/>} title={SettingEnum.ORGANIZATION} />}
      )
    }
    return tabs;
  }

  return defaultTabs;

}

export const getMain = (hardware: DeviceHardwareEnum, device: Device, connected: boolean, isAhp: boolean, isPrivate: boolean, capabilities: Map<number, Capabilities>) => {

  const capability: Capabilities = capabilities.get(hardware);

  const DEFAULT = new Map<SettingEnum, JSX.Element>([
    [SettingEnum.INFO, <Info/>],
    [SettingEnum.GENERAL, <General capabilities={capability}/>]
  ]);

  if(device.twinChild){
    return DEFAULT;
  }

  const DEVICE = new Map<SettingEnum, JSX.Element>([
    [SettingEnum.INFO, <Info/>]
  ]);

  if( capability.positioning ){
    DEVICE.set(SettingEnum.TRACKING, <Tracking  capabilities={capability} />);
    DEVICE.set(SettingEnum.GEOFENCE, <Geofence  />);
  }

  if( capability.reportsAccessPoints ){
    DEVICE.set(SettingEnum.INDOOR_LOCATION, <IndoorLocationCom  />);
  }

  if(capability.sensor){
    DEVICE.set(SettingEnum.SENSOR, <SensorTable />);
  }

  if(capability.walkTest){
    DEVICE.set(SettingEnum.WALKTEST, <Walktest />);
  }
  
  DEVICE.set(SettingEnum.GENERAL, <General capabilities={capability}/>);
  
  switch(hardware){
    case DeviceHardwareEnum.WATCH_ONE:
      return DEVICE;
    default:
      if(connected)
        return DEVICE;
      else
        return DEFAULT;
  }
}


interface IndoorLocationTitleProps extends WrappedComponentProps{
  icon?: JSX.Element;
  title: string;
}

const IndoorLocationTitle = injectIntl(({ intl: { formatMessage }, icon, title }: IndoorLocationTitleProps) =>
  <Title>
    {icon && React.cloneElement(icon, {inline: true, size: "medium"})}
    <TitleContent>{title}</TitleContent>
  </Title>
)

export interface IndoorLocationTabs{
  id: number;
  indoorLocation: IndoorLocation;
  shared: boolean;
  title: string;
}

type GetIndoorLocationTabs = (indoorLocations: IndoorLocation[], formatMessage: Function) => IndoorLocationTabs[];

export const getIndoorLocationTabs: GetIndoorLocationTabs = (indoorLocations, formatMessage: Function) => {
  if( indoorLocations !== undefined && indoorLocations.length < 1 ){
    return [];
  } else {
    let tabs:IndoorLocationTabs[] = [];
    indoorLocations.map((indoorLocation) => {
      tabs.push( { id: indoorLocation.inloId, title: indoorLocation.name ? indoorLocation.name : formatMessage({id:"newIndoorLocation", defaultMessage: "Add indoor location"}), indoorLocation: indoorLocation, shared: (indoorLocation.custId > 0) });
    });
    return tabs;
  }
}

export const excludeComponentWrapper = (tab: SettingEnum, dehaId: DeviceHardwareEnum) => {
  
  if(tab === SettingEnum.GX8_GENERAL && isGx8(dehaId)){
    return true;
  }

  if(tab === SettingEnum.INACTIVITY_EVENT && isGx8(dehaId)){
    return true;
  }
  
  return false;
}
